<template>
  <view-wrap class="bg-light">
    <div id="alerts">
      <h1>Alerts</h1>
      <div class="alert-block">
        <div class="header">
          <h4>Injured Players Email</h4>
          <a href="https://www.buymeacoffee.com/fantasyfalcon" class="green-alert" target="blank">
            Feature for our supporters
          </a>
        </div>

        <div class="descriptor">
          <p><i>Get notified when a player is injured so you can be the first to pick up teammates that will benefit</i></p>
        </div>
        <br/>
        <div class="settings">
          <ul>
            <li>Email address you'd like to receive the alerts to <input type="email" v-model="injuryAlert.email"/></li>
            <li>Phone you'd like to receive an SMS to (Coming soon):  <input type="phone" disabled="true" :value="injuryAlert.phone || '+11231231234'"></li>
            <li>Minimum season average minutes
              <select v-model="injuryAlert.min">
                <option v-for="min in minutes" :key="min" :value="min">{{min}} min</option>
              </select>
            </li>
            <li>Minimum expected days out
              <select v-model="injuryAlert.days">
                <option v-for="day in days" :key="day" :value="day">{{day}} days</option>
              </select>
            </li>
          </ul>
        </div>
        <br/>
        <p>Services required to detect injuries, transactional emails and SMS's cost money, which is why this feature requires a <b><a href="https://www.buymeacoffee.com/fantasyfalcon" target="blank">☕ contribution</a></b> to unlock.<br/>Once the contribution is done - please type in the email you used in <a href="https://www.buymeacoffee.com/fantasyfalcon" target="blank">buymeacoffee</a> here.</p>
        <br/>
        <div class="settings">
             <!-- <div v-if="!injuryAlert.is_enabled">
              <buy-me-a-coffee></buy-me-a-coffee>
            </div> -->
          <ul>
            <li>Buy me a coffee email address <input type="email" placeholder="email@address.com" v-model="injuryAlert.bbm_email"></li>
            <span v-if="showError" class="error" v-html="error"></span>
          </ul>
        </div>
        <br/>
        <p>
          <span v-if="showCongrats" class="congrats">Wohoo! The alert is setup and you're ready to go. Come back here if you need to tweak your settings or <a href="mailto:contact@fantasyfalcon.com">simply email me</a> for features or feedback!</span>
        </p>


        <div class="buttons-config ">
            <button @click="enableInjuryAlert()" class="dark">{{injuryAlertEnabled ? "Update" : "Enable" }}</button>
            <button v-if="injuryAlertEnabled" @click="disableInjuryAlert()" class="dark">Disable</button>
        </div>
      </div>
    </div>
  </view-wrap>
</template>

<script>
  import VueConfetti from 'vue-confetti'
  import Vue from 'vue'
  Vue.use(VueConfetti)
  const minutes = [25, 30];
  const days = [1, 3, 7, 14];
  export default {
    name: "alerts",
    data () {
      return {
        injuryAlert: {
          email: "",
          bbm_email: ""
        },
        showCongrats: false,
        error: "",
        minutes: [25, 30],
        days: [1, 3, 7, 14]
      }
    },
    components: {

    },
    created: async function () {
      const alerts = await this.$store.state.apiService.getAlertsInjuryConfig()
      this.injuryAlert = alerts[0]
      if(!this.injuryAlert.min) {
        this.injuryAlert.min = this.minutes[0];
      }
      if(!this.injuryAlert.days) {
        this.injuryAlert.days = this.days[0];
      }
      console.log(this.injuryAlert)
    },
    computed: {
      injuryAlertEnabled: function() {
        return this.injuryAlert.is_enabled || false;
      },
      showError: function() {
        return this.error && this.error.length > 0;
      },
    },
    methods: {
      enableInjuryAlert:  function () {
        this.$store.dispatch("isLoading", true);
        this.error = "";
        this.injuryAlert.is_enabled = true;
        this.$store.state.apiService.setAlertsInjuryConfig(this.injuryAlert).then(() => {
          console.log("success enabled alerts")
          this.$confetti.start();
          this.showCongrats = true;
          setTimeout(()=> {
            this.$confetti.stop();
          }, 2000);
          console.log(this.injuryAlert);
        }).catch((error)=> {
          this.injuryAlert.is_enabled = false;
          this.error = error.response.data.error;
          console.error(error.response.data);
        }).finally(() => {
          this.$store.dispatch("isLoading", false);
        })
      },
      disableInjuryAlert: function() {
        this.error = "";
        this.$store.dispatch("isLoading", true);
        this.injuryAlert.is_enabled = false;
        this.$store.state.apiService.setAlertsInjuryConfig(this.injuryAlert).then(() => {
          console.log("success enabled alerts")
          console.log(this.injuryAlert);
        }).catch((error)=> {
          console.error(error);
        }).finally(() => {
          this.$store.dispatch("isLoading", false);
        })
      }
    }
  };
</script>

<style src="./alerts.styl" lang="stylus" scoped></style>
